type IconProps = React.ComponentProps<'svg'>

export function CheckCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.71973 7.21973c0.29289-0.29289 0.76765-0.29289 1.06054 0 0.29289 0.29289 0.29289 0.76765 0 1.06054l-6 6c-0.29289 0.29289-0.76765 0.29289-1.06054 0l-3-3c-0.29289-0.29289-0.29289-0.76765 0-1.06054 0.29289-0.29289 0.76765-0.29289 1.06054 0l2.46973 2.46972 5.46973-5.46972z m-3.96973-7.21973c5.93706 0 10.75 4.81294 10.75 10.75 0 5.93706-4.81294 10.75-10.75 10.75-5.93706 0-10.75-4.81294-10.75-10.75 0-5.93706 4.81294-10.75 10.75-10.75z m0 1.5c-5.10863 0-9.25 4.14137-9.25 9.25 0 5.10863 4.14137 9.25 9.25 9.25 5.10863 0 9.25-4.14137 9.25-9.25 0-5.10863-4.14137-9.25-9.25-9.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
